import { useNotify } from 'react-admin';

export const notifyWithError = (notify: ReturnType<typeof useNotify>, error: unknown) => {

  if (error instanceof Error && error.message) {

    notify(error.message, { type: 'error' });

  } else {

    notify('ra.notification.http_error', { type: 'error' });

  }

};
